export function setupFloatingPlaceholder(input, label) {
    label.addEventListener('click', () => input.focus());

    const update = () => label.classList.toggle('is-floating', input.value !== '');

    input.addEventListener('keyup', update);
    input.addEventListener('focus', () => label.classList.add('is-floating'));
    input.addEventListener('blur', () => {
        if (input.value === '') label.classList.remove('is-floating');
    });

    update();
}

export function initFloatingPlaceholders(container) {
    container.querySelectorAll('.cbdonna-input-wrap').forEach(wrap => {
        const input = wrap.querySelector('.cbdonna-input, input, textarea, select');
        const label = wrap.querySelector('.cbdonna-input-label');
        if (input && label) setupFloatingPlaceholder(input, label);
    });
}

export default function initAllFloatingPlaceholders() {
    document.querySelectorAll('.cbdonna-input-wrap').forEach(wrap => {
        const input = wrap.querySelector('.cbdonna-input, input, textarea, select');
        const label = wrap.querySelector('.cbdonna-input-label');
        if (input && label) setupFloatingPlaceholder(input, label);
    });
}
